import AutoComplete from '~/pages/email/lib/components/AutoComplete'
import Form from '~/pages/email/lib/components/Form'
import { useEmail } from '~/pages/email/lib/hooks/useEmail'
import { StyledEmail as S } from '~/pages/email/styles'
import { Modal } from '~/shared/components/Modal'
import { Spinner } from '~/shared/components/Spinner'
import { useBulkSelector } from '~/shared/hooks/useBulkSelector'
import { selectError, selectLanguage } from '~/shared/store/common/selects'

const useSelectors = () =>
  useBulkSelector({
    error: selectError,
    lng: selectLanguage,
  })

const Email = () => {
  const { error } = useSelectors()

  const {
    areEmailTipsVisible,
    isErrorModalShown,
    isButtonDisabled,
    isStatusFetching,
    inputValue,
    isValidInputValue,
    filteredEmailDomains,
    handleSubmit,
    handleChange,
    handleCloseErrorModal,
    handlePrefilledEmail,
  } = useEmail()

  if (isStatusFetching) return <Spinner />

  return (
    <>
      <S.Root>
        <S.StyledContainer>
          <Form
            inputValue={inputValue}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            isButtonDisabled={isButtonDisabled}
            isValidInputValue={isValidInputValue}
          >
            {areEmailTipsVisible && !!filteredEmailDomains.length && (
              <AutoComplete
                domains={filteredEmailDomains}
                handlePrefilledEmail={handlePrefilledEmail}
              />
            )}
          </Form>
        </S.StyledContainer>
      </S.Root>

      <Modal onClose={handleCloseErrorModal} isShown={isErrorModalShown}>
        {error}
      </Modal>
    </>
  )
}

export default Email
